(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[501],{

/***/ "aSp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return Duration; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Duration = function Duration(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0004 25.016C20.5214 25.016 25.0134 20.523 25.0134 15C25.0134 9.47796 20.5214 4.98596 15.0004 4.98596C9.47738 4.98596 4.98438 9.47796 4.98438 15C4.98438 20.523 9.47738 25.016 15.0004 25.016ZM3 15C3 8.383 8.383 3 15 3C21.617 3 27 8.383 27 15C27 21.617 21.617 27 15 27C8.383 27 3 21.617 3 15ZM16 8.11166V14.5988L19.3294 16.9294C19.7844 17.2484 19.8984 17.8754 19.5814 18.3274C19.2654 18.7794 18.6374 18.8874 18.1824 18.5684L14.4394 15.9474C14.253 15.8166 14.1238 15.6342 14.0581 15.4333C14.0205 15.3274 14 15.2134 14 15.0947V8.11166C14 7.55566 14.449 7.10266 15 7.10266C15.551 7.10266 16 7.55566 16 8.11166Z"
  }));
};

/***/ })

}]);